let DataDict = {
	"link_type": [{
		"id": "1138",
		"label": "无操作",
		"value": "0"
	}, {
		"id": "1139",
		"label": "连接地址",
		"value": "1"
	}],
	"open_method": [{
		"id": "1136",
		"label": "当前窗口",
		"value": "0"
	}, {
		"id": "1137",
		"label": "新窗口/新标签",
		"value": "1"
	}],
	"org_level": [{
		"id": "118",
		"label": "部级",
		"value": "0"
	}, {
		"id": "119",
		"label": "省级",
		"value": "1"
	}, {
		"id": "120",
		"label": "市级",
		"value": "2"
	}, {
		"id": "121",
		"label": "县级",
		"value": "3"
	}, {
		"id": "122",
		"label": "其他",
		"value": "4"
	}],
	"org_type": [{
		"id": "1172",
		"label": "国家级农产品检测机构",
		"value": "11"
	}, {
		"id": "1173",
		"label": "农业农村部质量检测机构",
		"value": "12"
	}, {
		"id": "116",
		"label": "名特优新定点检测机构",
		"value": "8"
	}, {
		"id": "115",
		"label": "农产品地理标志定点检测机构",
		"value": "7"
	}, {
		"id": "114",
		"label": "绿色食品定点检测机构",
		"value": "6"
	}, {
		"id": "107",
		"label": "科研机构",
		"value": "0"
	}, {
		"id": "108",
		"label": "检测机构",
		"value": "1"
	}, {
		"id": "1171",
		"label": "农业转基因检测机构",
		"value": "10"
	}, {
		"id": "109",
		"label": "风险评估实验室",
		"value": "2"
	}, {
		"id": "110",
		"label": "风险评估实验站",
		"value": "3"
	}, {
		"id": "112",
		"label": "高校",
		"value": "4"
	}, {
		"id": "113",
		"label": "企业",
		"value": "5"
	}, {
		"id": "117",
		"label": "其他",
		"value": "9"
	}],
	"column_type": [{
		"id": "1129",
		"label": "首页",
		"value": "0"
	}, {
		"id": "1140",
		"label": "检测机构查询",
		"value": "7"
	}, {
		"id": "1130",
		"label": "检测服务",
		"value": "1"
	}, {
		"id": "1131",
		"label": "品质评价服务",
		"value": "2"
	}, {
		"id": "1132",
		"label": "质量合格证服务",
		"value": "3"
	}, {
		"id": "1133",
		"label": "溯源查询中心",
		"value": "4"
	}, {
		"id": "1134",
		"label": " 新闻动态",
		"value": "5"
	}, {
		"id": "1135",
		"label": "关于我们",
		"value": "6"
	}],
	"org_cert_type": [{
		"id": "123",
		"label": "CMA",
		"value": "0"
	}, {
		"id": "124",
		"label": "CATL",
		"value": "1"
	}, {
		"id": "125",
		"label": "CNAS",
		"value": "2"
	}, {
		"id": "126",
		"label": "其他",
		"value": "3"
	}],
	"show_home_page": [{
		"id": "1125",
		"label": "否",
		"value": "0"
	}, {
		"id": "1126",
		"label": "是",
		"value": "1"
	}],
	"geo_rz_type": [{
    "id": "101",
    "label": "中国农产品地理标志",
    "value": "0"
  }, {
    "id": "102",
    "label": "中国地理标志",
    "value": "1"
  }, {
    "id": "103",
    "label": "中欧互认互保地理标志",
    "value": "2"
  }],
      'launch_start_type': [
        {
            id: "186",
            label: "上旬",
            value: "0",
        },
        {
            id: "187",
            label: "中旬",
            value: "1",
        },
        {
            id: "188",
            label: "下旬",
            value: "2",
        },
    ],
	'rz_type': [
        {
            "id": "166",
            "label": "地理标志产品",
            "value": "0"
        }, 
        {
            "id": "167",
            "label": "名特优新农产品",
            "value": "4"
        }, 
        {
            "id": "168",
            "label": "区域特色农产品",
            "value": "2"
        }
    ],
	"status": [{
		"id": "1127",
		"label": "禁用",
		"value": "0"
	}, {
		"id": "1128",
		"label": "启用",
		"value": "1"
	}],"del_flag":[{"id":"10","label":"正常","value":"0"},{"id":"20","label":"已删除","value":"1"}],"diff_country_type":[{"id":"790","label":"中国","value":"0"},{"id":"800","label":"中国香港","value":"1"},{"id":"810","label":"中国台湾","value":"2"},{"id":"820","label":"中国澳门","value":"3"},{"id":"830","label":"CAC","value":"4"},{"id":"840","label":"欧盟","value":"5"},{"id":"850","label":"AOAC","value":"6"},{"id":"860","label":"FAO","value":"7"},{"id":"870","label":"日本","value":"8"},{"id":"880","label":"IDF","value":"9"},{"id":"890","label":"美国","value":"10"}],"version_type":[{"id":"50","label":"Android","value":"0"},{"id":"60","label":"IOS","value":"1"}],"handle_statue":[{"id":"110","label":"未处理","value":"0"},{"id":"120","label":"已处理","value":"1"}],"statue":[{"id":"130","label":"启用","value":"0"},{"id":"140","label":"停用","value":"1"}],"problem_type":[{"id":"70","label":"功能问题","value":"0"},{"id":"80","label":"产品建议","value":"1"},{"id":"90","label":"账号问题","value":"2"},{"id":"100","label":"其他问题","value":"3"}],"sfqzgx_flag":[{"id":"30","label":"是","value":"0"},{"id":"40","label":"否","value":"1"}],"standard_rule_type":[{"id":"900","label":"现行","value":"0"},{"id":"910","label":"将实施","value":"1"},{"id":"920","label":"将废止","value":"2"},{"id":"930","label":"废止","value":"3"}]
}
 module.exports = DataDict